import { toast, type ExternalToast } from 'sonner'

function useLocalNotifications() {
  return {
    setNotification: (
      type: 'success' | 'error' | 'warning' | 'info',
      message: string,
      data?: ExternalToast
    ) => {
      if (type === 'success') {
        toast.success(message, data)
      } else if (type === 'info') {
        toast.info(message, data)
      } else if (type === 'warning') {
        toast.warning(message, data)
      } else if (type === 'error') {
        toast.error(message, data)
      } else {
        throw new Error(`Invalid notification type: ${type}`)
      }
    },
  }
}

export { useLocalNotifications }
